import EFPicture from 'elem/compCommon/EFPicture';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function C() {
    const { useLang, useRouter, useState, useEffect } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('offgrid');
    const [gap, setGap] = useState(0);
    const cards: any = [
        {
            title: t('secC_card1_title'),
            desc: t('secC_card1_desc'),
            arr: [
                {
                    k: t('secC_card1_key1'),
                    v: t('secC_card1_value1'),
                },
                {
                    k: t('secC_card1_key2'),
                    v: t('secC_card1_value2'),
                },
            ],
        },
        {
            title: t('secC_card2_title'),
            desc: t('secC_card2_desc'),
            arr: [
                {
                    k: t('secC_card2_key1'),
                    v: t('secC_card2_value1'),
                },
                {
                    k: t('secC_card2_key2'),
                    v: t('secC_card2_value2'),
                },
            ],
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW > 1024) {
                    return setGap(0);
                } else if (winW >= 768) {
                    return setGap(12);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, []);

    return (
        <div id="off-grid-C" className={`off-grid-C off-grid-box ${css['off-grid-C']}`}>
            <div className="text-info">
                <h2 className="title">{t('secC_title')}</h2>
                <p className="desc">{t('secC_desc')}</p>
            </div>
            <div className="img-box">
                <EFPicture
                    src={`/responsive/picture/off-grid/3.jpg`}
                    srcPad={`/responsive/picture/off-grid/3_768.jpg`}
                    srcMobile={`/responsive/picture/off-grid/3_768.jpg`}
                    alt={t('secC_title')}
                />
            </div>
            <Swiper className="swiper-box" spaceBetween={gap} slidesPerView={'auto'} initialSlide={0}>
                {cards?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        <p className="card-title">{card?.title}</p>
                        <p className="card-desc">{card?.desc}</p>
                        <ul className="card-lists">
                            {card?.arr?.map((item: any) => (
                                <li className={`card-item`} key={`${k}_${item?.v}`}>
                                    {item?.k && <p className="item-key">{item?.k}</p>}
                                    <p className={`item-value`}>{item?.v}</p>
                                </li>
                            ))}
                        </ul>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
